import { Component } from '@angular/core';
import { FeaturePreviewComponent } from '../feature-preview.component';

@Component({
  selector: 'app-feature-preview-projekt',
  templateUrl: './projekt.component.html',
})
export class FeaturePreviewProjekt extends FeaturePreviewComponent {}
